// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-wrapper-FtUpxy{width:100%;position:relative}.input-wrapper-FtUpxy span{width:100%}.error-wrapper-amWL8g .semi-input-wrapper{border:1px solid #f93920}.error-content-OcbxcM{height:20px}.error-float-v53a7a{white-space:nowrap;width:100%;position:absolute}.error-text-W3xpef{color:#f93920;padding-top:2px;font-size:12px;position:absolute}.input-EP2aeu input{text-overflow:ellipsis;overflow:hidden}.limit-count-xXMxxt{color:var(--light-usage-text-color-text-3,rgba(28,31,35,.35));padding-left:8px;padding-right:12px;font-size:12px;font-style:normal;font-weight:400;line-height:16px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-wrapper": `input-wrapper-FtUpxy`,
	"inputWrapper": `input-wrapper-FtUpxy`,
	"error-wrapper": `error-wrapper-amWL8g`,
	"errorWrapper": `error-wrapper-amWL8g`,
	"error-content": `error-content-OcbxcM`,
	"errorContent": `error-content-OcbxcM`,
	"error-float": `error-float-v53a7a`,
	"errorFloat": `error-float-v53a7a`,
	"error-text": `error-text-W3xpef`,
	"errorText": `error-text-W3xpef`,
	"input": `input-EP2aeu`,
	"limit-count": `limit-count-xXMxxt`,
	"limitCount": `limit-count-xXMxxt`
};
export default ___CSS_LOADER_EXPORT___;
